import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation("translations");

  return (
    <footer>
      <div>
        <Link className="inline" to="/">Sensotrend SignIn</Link> v{process.env.REACT_APP_VERSION}
      </div>
      <div>
        &copy;2020 <a className="inline" href="/">Sensotrend Oy</a>
      </div>
      <div>
        <span><a className="inline" href="/connect/eula">{t('Terms')}</a></span>
        <span className="separator">&middot;</span>
        <span><a className="inline" href="/connect/privacy">{t('Privacy')}</a></span>
        <span className="separator">&middot;</span>
        <span><a className="inline" href="/connect/instructions">{t('Help')}</a></span>
      </div>
    </footer>
  );
}

export default Footer;
